var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { display: "block" }, attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title.edit-button")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("label.text") },
                    model: {
                      value: _vm.value.Text,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Text", $$v)
                      },
                      expression: "value.Text",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("app-product-sku-autocomplete", {
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event)
                      },
                    },
                    model: {
                      value: _vm.product,
                      callback: function ($$v) {
                        _vm.product = $$v
                      },
                      expression: "product",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("app-color-picker", {
                    attrs: {
                      color: _vm.value.Color,
                      label: _vm.$ct("label.color"),
                      "preset-colors": ["#f00", "#00ff00", "#00ff0055"],
                      compact: true,
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Color,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Color", $$v)
                      },
                      expression: "value.Color",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-row", [_c("w-col", { attrs: { sm: "12" } })], 1),
          _c("w-row", [_c("w-col", { attrs: { sm: "12" } })], 1),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel mr",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "trash" },
              on: {
                click: function ($event) {
                  return _vm.deleteButton()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.delete")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }